(async () => {
    const {
      updateURLParams,
      historyPush,
      parseHTML,
      getParentSection
    } = await import(window.theme.modules.utils);
    
    const isEqual = (arr1, arr2) => arr1.toString() === arr2.toString();
    const strEsc = (str) => str.replace(/["\\]/g, '\\$&');
    const parseJSON = (el) => JSON.parse(el.textContent)
    const baseComponent = await import(window.theme.modules.baseComponent);
  
    customElements.define('product-variant-selector', class extends baseComponent.default {
      elements = {
        variantsJSON: '[data-variants-json]',
        optionsJSON: '[data-options-with-values]'
      };
      
      render() {
       
        this.cache = {};
        this.isProductPage = this.hasAttribute('product-page');
        this.showPricesInDropdown = this.hasAttribute('show-prices-in-dropdown');
        this.variantsData = parseJSON(this.$variantsJSON);
        this.optionsData = parseJSON(this.$optionsJSON);
        this._getDefaultVariant();
        this._checkUnavailable();

        if(this.showPricesInDropdown){
        var ShopifyObj = ShopifyObj || {};
  
        // Required functionality from depricated options_selection.js
        ShopifyObj.arrayIncludes = function(e, t) {
          for (var n = 0; n < e.length; n++)
              if (e[n] == t) return !0;
          return !1
        }, ShopifyObj.uniq = function(e) {
            for (var t = [], n = 0; n < e.length; n++) ShopifyObj.arrayIncludes(t, e[n]) || t.push(e[n]);
            return t
        }
        ShopifyObj.optionsMap = {};


      for (var i=0; i<this.variantsData.length; i++) {
          var variant = this.variantsData[i];
      // Gathering values for the 1st drop-down.
        var key = variant.option1;
        ShopifyObj.optionsMap[key] = ShopifyObj.optionsMap[key] || [];
        ShopifyObj.optionsMap[key].push(variant.price);
        ShopifyObj.optionsMap[key] = ShopifyObj.uniq(ShopifyObj.optionsMap[key]);
      // Gathering values for the 2nd drop-down.
      if (this.optionsData.length == 2) {
        var key = variant.option2;
        ShopifyObj.optionsMap[key] = ShopifyObj.optionsMap[key] || [];
        ShopifyObj.optionsMap[key].push(variant.price);
        ShopifyObj.optionsMap[key] = ShopifyObj.uniq(ShopifyObj.optionsMap[key]);
        var key = variant.option1 + ' / ' + variant.option2;
        ShopifyObj.optionsMap[key] = ShopifyObj.optionsMap[key] || [];
        ShopifyObj.optionsMap[key].push(variant.price);
        ShopifyObj.optionsMap[key] = ShopifyObj.uniq(ShopifyObj.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (this.optionsData.length == 3) {
        var key = variant.option3;
        ShopifyObj.optionsMap[key] = ShopifyObj.optionsMap[key] || [];
        ShopifyObj.optionsMap[key].push(variant.price);
        ShopifyObj.optionsMap[key] = ShopifyObj.uniq(ShopifyObj.optionsMap[key]);
        var key = variant.option1 + ' / ' + variant.option2 + ' / ' + variant.option3
        ShopifyObj.optionsMap[key] = ShopifyObj.optionsMap[key] || [];
        ShopifyObj.optionsMap[key].push(variant.price);
        ShopifyObj.optionsMap[key] = ShopifyObj.uniq(ShopifyObj.optionsMap[key]);
      }
    }

        this.optionsWithPriceData = ShopifyObj;
        this._checkOptionsPrices(true);  
        }     
        
        
        this.addEventListener('change', this._variantChangeHandler.bind(this));
        this.on('qtyStatusUpdate', (e, data) => {
          this.cache[+data.variantId] = data.html.outerHTML
        }, false)
        this._setInititalCache();
      };


      _checkOptionsPrices(firstLoad){
         var _this = this;
        if(this.querySelectorAll("input:checked")){ 
         if(firstLoad){ 

              var found_pick_an_option = false;
              var selectedOptionsArr = [];
              this.querySelectorAll("input:checked").forEach(function(input){
                if(input.value == "pick-an-option"){
                  found_pick_an_option = true;
                }else{
                  selectedOptionsArr.push(input.value);
                }  
             });
    
              if(found_pick_an_option){
                this.querySelectorAll("input").forEach(function(input){
                  if(input.value != "pick-an-option"){
                    var pricePlaceholder = input.closest("label").querySelector(".option_price_placeholder");
                    if(pricePlaceholder){
                      var pricesArr = _this.optionsWithPriceData.optionsMap[input.value].sort((a, b) => a - b);
                      if(pricesArr.length > 1){
                        var minPrice = pricesArr[0];
                        var maxPrice = pricesArr[pricesArr.length - 1];
                        pricePlaceholder.innerHTML = " ("+window.Theme.utils.formatMoney(minPrice)+ " - "+window.Theme.utils.formatMoney(maxPrice)+")";
                      }else{
                        var minPrice = pricesArr[0];
                        pricePlaceholder.innerHTML = " ("+window.Theme.utils.formatMoney(minPrice)+")";
                      }
                    }
                  }
                });

              }else{

                    if(_this.optionsData.length == 1){
                      this.querySelectorAll("input").forEach(function(input){
                      if(input.value != "pick-an-option"){
                        var pricePlaceholder = input.closest("label").querySelector(".option_price_placeholder");
                        if(pricePlaceholder){
                          var pricesArr = _this.optionsWithPriceData.optionsMap[input.value].sort((a, b) => a - b);
                          if(pricesArr.length > 1){
                            var minPrice = pricesArr[0];
                            var maxPrice = pricesArr[pricesArr.length - 1];
                            pricePlaceholder.innerHTML = " ("+window.Theme.utils.formatMoney(minPrice)+ " - "+window.Theme.utils.formatMoney(maxPrice)+")";
                          }else{
                            var minPrice = pricesArr[0];
                            pricePlaceholder.innerHTML = " ("+window.Theme.utils.formatMoney(minPrice)+")";
                          }
                        }
                      }
                    });
                  }else{
            
                     this.querySelectorAll("input").forEach(function(input){
                      var optionIndex = input.getAttribute("data-option-index") * 1;
                       var pricePlaceholder = input.closest("label").querySelector(".option_price_placeholder");
                        if(pricePlaceholder){
                          if(optionIndex == 0){
                             var optionKey = input.value + " / " + selectedOptionsArr[1];            
                          }else{
                             var optionKey = selectedOptionsArr[0] + " / " + input.value;
                          }
             
                          var pricesArr = _this.optionsWithPriceData.optionsMap[optionKey].sort((a, b) => a - b);
                          if(pricesArr.length > 1){
                            var minPrice = pricesArr[0];
                            var maxPrice = pricesArr[pricesArr.length - 1];
                            pricePlaceholder.innerHTML = " ("+window.Theme.utils.formatMoney(minPrice)+ " - "+window.Theme.utils.formatMoney(maxPrice)+")";
                          }else{
                            var minPrice = pricesArr[0];
                            pricePlaceholder.innerHTML = " ("+window.Theme.utils.formatMoney(minPrice)+")";
                          }
                        }

                     });
                  }
                
              }    
         }else if(_this.optionsData.length != 1){
              var found_pick_an_option = false;
              var optionIndex = "";
              var selectedOptionValue = "";
              var selectedOptionsArr = [];
              this.querySelectorAll("input:checked").forEach(function(input,index){
                if(input.value == "pick-an-option"){
                  found_pick_an_option = true;
                  optionIndex = input.getAttribute("data-option-index") * 1;
                }else{
                  selectedOptionValue = input.value;
                  selectedOptionsArr.push(input.value);
                }  
             });
              if(found_pick_an_option){
                this.querySelectorAll("input").forEach(function(input){
                  if(input.value != "pick-an-option" && (input.getAttribute("data-option-index") * 1) == optionIndex){
                    var pricePlaceholder = input.closest("label").querySelector(".option_price_placeholder");
                    if(pricePlaceholder){
                      if(optionIndex == 0){
                         var optionKey = input.value + " / " + selectedOptionValue;            
                      }else{
                         var optionKey = selectedOptionValue + " / " + input.value;
                      }
         
                      var pricesArr = _this.optionsWithPriceData.optionsMap[optionKey].sort((a, b) => a - b);
                      if(pricesArr.length > 1){
                        var minPrice = pricesArr[0];
                        var maxPrice = pricesArr[pricesArr.length - 1];
                        pricePlaceholder.innerHTML = " ("+window.Theme.utils.formatMoney(minPrice)+ " - "+window.Theme.utils.formatMoney(maxPrice)+")";
                      }else{
                        var minPrice = pricesArr[0];
                        pricePlaceholder.innerHTML = " ("+window.Theme.utils.formatMoney(minPrice)+")";
                      }
                    }
                  }
                });

              }else{
                this.querySelectorAll("input").forEach(function(input){
                      var optionIndex = input.getAttribute("data-option-index") * 1;
                       var pricePlaceholder = input.closest("label").querySelector(".option_price_placeholder");
                        if(pricePlaceholder){
                          if(optionIndex == 0){
                             var optionKey = input.value + " / " + selectedOptionsArr[1];            
                          }else{
                             var optionKey = selectedOptionsArr[0] + " / " + input.value;
                          }
             
                          var pricesArr = _this.optionsWithPriceData.optionsMap[optionKey].sort((a, b) => a - b);
                          if(pricesArr.length > 1){
                            var minPrice = pricesArr[0];
                            var maxPrice = pricesArr[pricesArr.length - 1];
                            pricePlaceholder.innerHTML = " ("+window.Theme.utils.formatMoney(minPrice)+ " - "+window.Theme.utils.formatMoney(maxPrice)+")";
                          }else{
                            var minPrice = pricesArr[0];
                            pricePlaceholder.innerHTML = " ("+window.Theme.utils.formatMoney(minPrice)+")";
                          }
                        }

                     });
              }
         }
      }
      }
  
      _getDefaultVariant() {
        this.variant = this.variantsData.find(v => v.id === +this.getAttribute('current-variant-id'));
      };

      _setInititalCache() {
        const parentSection = this.getParentSection();
        this.cache[this.variant.id] = parentSection.outerHTML;
      };
  
      _checkUnavailable() {
        this.optionsData.map((option, i) => {
          let optionsToCheck = [...this.variant.options];
          option.values.map(optionValue => {
            optionsToCheck[i] = optionValue;
            const match = this._findVariantByOptions(optionsToCheck);
            this._toggleOption(option.name, optionValue, !match);   
          })
        })
      };
  
      _toggleOption(name, value, disable) {
        const targetInput = this.querySelector(`[name="${strEsc(name)}"][value="${strEsc(value)}"`);
        disable
          ? targetInput.setAttribute('data-unavailable', '')
          : targetInput.removeAttribute('data-unavailable');
      };
  
      _variantChangeHandler(e) {
        if(e.target.closest("product-option-picker")){
          if(e.target.closest("product-option-picker").querySelector(".error-select")){
            e.target.closest("product-option-picker").querySelector(".error-select").classList.remove("error-select");
            e.target.closest("product-option-picker").querySelector("p").remove();
          }
        }
        if (!e.detail?.synthetic) {
            this._selectVariantByOption(e.target);
            const { queryURL, currentURL } = updateURLParams({ 'variant': this.variant.id }, this.sectionId, window.location.origin + this.getAttribute('product-url'));

            if(this.showPricesInDropdown){
            if(this.querySelectorAll("input:checked")){
              var found_pick_an_option = false;
              this.querySelectorAll("input:checked").forEach(function(input){
                if(input.value == "pick-an-option"){
                  found_pick_an_option = true;
                }  
             });
    
              if(found_pick_an_option){

                this._fetchPageWithVariantForImage(queryURL, (html) => {
                this.forwardEvent('variantChangeImage', {
                        html: parseHTML(html),
                        variant: this.variant
                    })
                });

                this._checkOptionsPrices(false);
                return;
              }
             
            }

            this._checkOptionsPrices(false);
            }
            if (this.isProductPage) historyPush(currentURL);
            this._checkUnavailable();

            if(this.showPricesInDropdown){
              var cached = false;
            }else{
              var cached = this.cache[this.variant.id];
            }
            // 
            // console.log(cached);
            // console.log(this.cache);

            if (cached) {
              this.forwardEvent('variantChange', {
                  html: parseHTML(cached),
                  variant: this.variant
              })
            } else {
              this._fetchPageWithVariant(queryURL, (html) => {
                this.cache[this.variant.id] = html;
                this.forwardEvent('variantChange', {
                        html: parseHTML(html),
                        variant: this.variant
                    })
                });
            }
            
        }  
      };
  
      _selectVariantByOption(target) {
        let valueIndex = this.optionsData.findIndex(option => option.name === target.name);
        if (target.hasAttribute('data-unavailable')) {
          this.variant = this.variantsData.find(variant => variant.options[valueIndex] === target.value);
          this._toogleInputs(target)
        } else {
          let optionsToFind = [...this.variant.options];
          optionsToFind[valueIndex] = target.value;
          this.variant = this._findVariantByOptions(optionsToFind);
        }
      };
  
      _toogleInputs(target) {
        this.variant.options.map((option, i) => {
          if(option !== target.value) {
            const input = this.querySelector(`input[value="${strEsc(option)}"][name="${strEsc(this.optionsData[i].name)}"]`);
            input.checked = true;
            input.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { synthetic: true } }));
          }
        }) 
      };
  
      _findVariantByOptions(options) {
        return this.variantsData.find(variant => isEqual(variant.options, options));
      };
  
      _updateSwatchLable(swatchInput) {
        swatchInput.closest('product-variant-swatch').querySelector('[data-swatch-value]').textContent = swatchInput.value;
      };
  
      _fetchPageWithVariant(url, onResponse) {
        this.forwardEvent('variantLoading');
        return fetch(url)
        .then(response => response.text())
        .then(responseText => {
          onResponse(responseText);
        });
      };    

      _fetchPageWithVariantForImage(url, onResponse) {
        return fetch(url)
        .then(response => response.text())
        .then(responseText => {
          onResponse(responseText);
        });
      };    
      
    });

    customElements.define('product-option-picker', class extends baseComponent.default {
        elements = {
            value: '[data-option-value]'
        }
        render() {
            this.addEventListener('change', e => {
                if(this.$value) {
                    this.$value.innerText = e.target.value;
                }
            })
        }
    })
  })();